

// Components.
import Music from "../components/Music";
import Name from "../components/Name";
import Photos from "../components/Photos";
import Work from "../components/Work";

const Home = (props) => {


  return (
    <div className='mainContainer'>
      <div className='main'>
        <div className='page-content borderBottom'>
          <Photos />
        </div>
        <div className='page-content borderBottom'>
          <Work />
        </div>
        <div className='page-content borderBottom'>
          <Music />
        </div>
        <div className='page-content'>
          <Name />
        </div>
      </div>
    </div >
  );
};

export default Home;